module.exports = __webpack_public_path__ + "static/media/card-platinum.292878df.png";